export const CLIENT_ID = '756497226087-psd2114veq4ooe1f2gvqb9dmveg0a5fa.apps.googleusercontent.com';